import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLaunchpool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 11a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z"
    />
    <path
      fill="#F7A600"
      d="M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM2.238 18.225c.339-.282.914-.301 1.285-.044l1.81 1.257c.376.261.962.237 1.297-.055l.52-.45c1.122-.974 3.139-.917 4.16.118.345.35 1.035.35 1.38 0 1.021-1.035 3.038-1.092 4.16-.119l.52.451c.335.292.92.316 1.297.055l1.81-1.257c.371-.257.946-.238 1.285.044.339.281.313.718-.058.975l-1.81 1.257c-1.129.784-2.886.71-3.893-.164l-.52-.451c-.36-.313-1.009-.295-1.337.038-1.072 1.085-3.216 1.085-4.288 0-.328-.333-.977-.351-1.338-.038l-.52.45c-1.006.875-2.763.95-3.892.165L2.296 19.2c-.37-.257-.397-.694-.058-.975Z"
    />
  </svg>
);
export default SvgTwoColorLaunchpool;
